// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { floppyDisk16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-floppy-disk': IconFloppyDisk;
    }
}

/**
 * The icon component for the 'floppyDisk' icon
 */
export class IconFloppyDisk extends Icon {
    public constructor() {
        super(floppyDisk16X16);
    }
}

registerIcon('icon-floppy-disk', IconFloppyDisk);
export const iconFloppyDiskTag = 'nimble-icon-floppy-disk';
